module.exports = "/_next/static/images/slide4-7b7691fb59d485efd4d016137010a18e.jpg.webp";